import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnChanges, OnDestroy {

  private static readonly FADE_DURATION_MS = 350;

  @Input() active = true;

  visible = true;
  fading = false;

  private hideTimer?: ReturnType<typeof setTimeout>;

  ngOnChanges(changes: SimpleChanges): void {

    if (!changes['active']) {
      return;
    }

    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }

    if (this.active) {
      this.visible = true;
      this.fading = false;
      return;
    }

    this.fading = true;

    this.hideTimer = setTimeout(() => {
      this.visible = false;
      this.fading = false;
      this.hideTimer = undefined;
    }, LoaderComponent.FADE_DURATION_MS);
  }

  ngOnDestroy(): void {

    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }

  }
}
